module Meevo.Plugins.Services {
    "use strict";
    /**
    * Employees Section
    */
    export class EmployeesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Service> {

        COLOR_STANDARD: string = "#FFFFFF";
        COLOR_REVERT: string = "#E4E410";

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private numberOfPriceLevelsToDisplay;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            private securityChecker: Meevo.Components.Common.ISecurityService,
            sectionSecurityKey?: string,
        ) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            this.numberOfPriceLevelsToDisplay = this.appSettings.APP_BUSINFOSETTINGS.registerSettings.defaultPriceLevelsForService

        }

        enableOnlineBooking(item: any) {
            if (!item.allowBookOnline || !!item.isEmployeeBookableOnline) return;
            this.modalService.confirmHandler('LABEL_CONFIGURE_EMPLOYEE_TO_BE_BOOKABLE_ONLINE')
                .then((res: boolean) => {
                    if (res) {
                        this.dataService.customMethodData('/api/Employee/AllowOnlineBooking', 'PATCH', {
                            employeesAllowOnlineBooking: [item.employeeGlobalId],
                            selectAll: false,
                            outsideOBSettings: true
                        }).then((res) => {
                            item.isEmployeeBookableOnline = true;
                        })
                    }
                })

        }

        getEmployeesDefaultCriteria() {
            let selected = !!this.model && this.model.numberOfEmployeesAssigned < 1 ? '' : 0
            return { 'doesNotPerform': selected };
        }

        toggledAllItems(items: any, value?: boolean): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES_ACTION_EXPAND))
                _.map(items,
                    (i: any) => {

                        if (Model.Guard.isNothing(i.priceLevel)) {
                            const priceLevel: any = _.first(i.priceLevelSelection);
                            i.priceLevel = priceLevel.id;
                            i.price = priceLevel.price;
                        }

                        i.expandItem = value;
                    });

        }

        toggleCanPerform(item: any): boolean {
            if (!item.doesNotPerform) {
                item.expandItem = true;
                if (!this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES_ACTION_EXPAND))
                    item.expandItem = false;
                if (Model.Guard.isNothing(item.priceLevel)) {
                    const priceLevel: any = _.first(item.priceLevelSelection);
                    item.priceLevel = priceLevel.id;
                    item.price = priceLevel.price;
                }
                return true;
            }
            else {
                item.expandItem = false;
                return false;
            }

        }

        toggleExpandItem(item: any): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_SERVICES_ACTION_EXPAND)
            ) {
                if (Model.Guard.isNothing(item.priceLevel)) {
                    const priceLevel: any = _.first(item.priceLevelSelection);
                    item.priceLevel = priceLevel.id;
                    item.price = priceLevel.price;
                }

                item.expandItem = !item.expandItem;
            }
        }

        setServicePriceLevels(item?: any): void {
            let priceLevelsForService = angular.copy(item.priceLevelSelection);
            let lastPriceLevelWithValue = _.findIndex(priceLevelsForService.reverse(), (pl: any) => { return pl.price !== 0 });
            let numberOfPriceLevelsWithValue = lastPriceLevelWithValue > 0 ? item.priceLevelSelection.length - lastPriceLevelWithValue : lastPriceLevelWithValue;
            this.numberOfPriceLevelsToDisplay = numberOfPriceLevelsWithValue > this.numberOfPriceLevelsToDisplay ? numberOfPriceLevelsWithValue : this.numberOfPriceLevelsToDisplay;
        }

        updateNewPrice(priceLevel: any, priceLevelSelection: any, item): void {
            let newValue: any = _.findWhere(priceLevelSelection, { id: priceLevel });
            if (newValue) {
                item.price = newValue.price;
                item.priceRevertTo = newValue.price;
            }
        }

        showPriceLevel(index): boolean {
            let show = index < this.numberOfPriceLevelsToDisplay;
            return show;
        }

        onBlurOfPrice(item: any): any {
            if (!item.isPriceOverriden && item.price != item.priceRevertTo) {
                item.isPriceOverriden = true;
            }
        }

        getPriceBackgroundColor(item: any): any {
            return this.showPriceRevertTo(item) ? this.COLOR_REVERT : this.COLOR_STANDARD;
        }

        showPriceRevertTo(item: any): boolean {
            if ((item.priceRevertTo && item.price != item.priceRevertTo) || item.isPriceOverriden) {
                item.isPriceOverriden = true;
                return true;
            }
            return false;
        }

        updatePriceRevertTo(item: any): void {
            this.updateNewPrice(item.priceLevel, item.priceLevelSelection, item);
            item.isPriceOverriden = false;
        }

        toggleEditServiceSteps(isEditing: boolean, item: any): void {
            if (!isEditing) return;
            item.isEditable = true;
        }

        showStepRevertTo(step: any): boolean {
            if (step.minutes != step.minutesRevertTo || step.isMinutesOverriden) {
                step.isMinutesOverriden = true;
                return true;
            }
            return false;
        }

        updateMinutesRevertTo(step: any): void {
            step.minutes = step.minutesRevertTo;
            step.isMinutesOverriden = false;
        }
    }
}